import styled from "@emotion/styled";

const ChildE = () => {
  return (
    <Container>
      <Title>Child Safety Standard Policy</Title>
      <Pre>
        {`\n`}
        {`Handy Labs Co., Ltd. (hereinafter referred to as "Company") prioritizes the protection of children's personal information and safe service usage, and implements policies to protect the personal information of children under 14 years of age in accordance with relevant laws.\n\n`}
        
        <B>1. Legal Guardian Consent Requirement</B>
        {`\nWhen the Company collects personal information from children under 14 years of age, it must obtain consent from legal guardians before collection and use.\n- Consent methods: Use of legitimate verification procedures such as email verification, mobile phone verification, written consent, etc.\n- Legal guardians may request access, modification, deletion, processing suspension, etc. at any time.\n\n`}
        
        <B>2. Service Usage Restrictions and Protective Measures</B>
        {`\n- Content and community functions that may be inappropriate for children are restricted by default.\n- A reporting system is operated to quickly respond when harmful content occurs.\n\n`}
        
        <B>3. Minimal Collection of Personal Information and Prohibition of Use for Other Purposes</B>
        {`\n- The Company collects children's personal information only to the minimum extent necessary for service provision.\n- Collected information is not provided to third parties without consent and is not used for other purposes.\n\n`}
        
        <B>4. Personal Information Protection Measures</B>
        {`\n- Children's personal information is protected separately according to enhanced security policies compared to general member information.\n- Internal leakage is prevented through minimization of access privileges and security training for staff.\n\n`}
        
        <B>5. Rights of Children and Guardians</B>
        {`\n- Access, modification, deletion, and withdrawal of consent for personal information can be requested at any time.\n- When requested, measures are taken without delay and the results are notified to legal guardians.\n\n`}
        
        <B>6. CSAE and CSAM Blocking</B>
        {`\n- Systems capable of automatically filtering CSAE (Child Sexual Abuse and Exploitation) and CSAM (Child Sexual Abuse Material) are operating at all times.\n\n`}
        
        <B>7. Designation of Child and Youth Protection Officers</B>
        {`\n- Child and youth protection officers and managers are designated as follows to perform duties such as blocking and managing harmful information for children and youth, and establishing protection policies from harmful information for children and youth.\n\n`}
        
        <SubTitle>
          <B>Youth Protection Manager and Child Safety Officer</B>
        </SubTitle>
        {`\nYouth Protection Manager and Child Safety Officer: Seunggu Jung (CTO, jun@handylabs.io)\n\n`}
        
        <B>8. Policy Notification and Changes</B>
        {`\nThis policy may be changed according to relevant laws and company policies, and changes will be announced through the website or app.\n\n`}
        
        <SubTitle>
          <B>Announcement and Effective Date</B>
        </SubTitle>
        {`\nChild Safety Standard Policy Announcement Date: February 05, 2025\nChild Safety Standard Policy Effective Date: February 25, 2025\n`}
      </Pre>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  background-color: #212432;
`;

const Title = styled.div`
  margin: 30px 0;
  color: #fff;
  font-size: 35px;
  font-weight: bold;
  padding-bottom: 35px;
  border-bottom: 1px solid #8b8b8b;
`;

const SubTitle = styled.div`
  text-align: left;
`;

const Pre = styled.pre`
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  color: #fff;
  font-family: monospace;
  /* line-height: 1.5; */
  line-height: 25px;
`;

const B = styled.span`
  font-weight: bold;
`;

export default ChildE;